import store from "@/store"
import api from "@/request/api"

var token = localStorage.getItem("token")
if (token) {
    store.commit("setLogin", api.getInfo({ token }).then(res => {
        store.commit("setUser", JSON.parse(res.data.user))
    }, () => {

    }))
}